import {Location} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {RoutingCenterService} from '../../../../services/routing-center/routing-center.service';

@Component({
  selector: 'bw-index-heading',
  templateUrl: './index-heading.component.html',
  styleUrls: ['./index-heading.component.scss']
})
export class IndexHeadingComponent implements OnInit, OnDestroy {
  subscribe: Subscription;
  routing: Array<any> = [];

  constructor (private router: Router, private location: Location, private routingCenter: RoutingCenterService) {
    this.subscribe = this.router.events.subscribe(event => {
      this.routing = routingCenter.getHeadingRouting(decodeURI(location.path()));
    });
  }

  ngOnInit () {
  }

  ngOnDestroy (): void {
    try {
      this.subscribe.unsubscribe();
    } catch (e) {}
  }

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-heading/index-heading.component.ts